import { entra  } from '../variables/identityUrl'
export const IDENTITY_CONFIG = {
    authority: entra ? process.env.REACT_APP_AUTH_URL_ENTRA : process.env.REACT_APP_AUTH_URL,
    client_id: entra ? process.env.REACT_APP_IDENTITY_CLIENT_ID_ENTRA : process.env.REACT_APP_IDENTITY_CLIENT_ID,
    redirect_uri: window.location.protocol + "//" + window.location.hostname + (window.location.port != "" ? ":" + window.location.port : "") + process.env.REACT_APP_REDIRECT_URL,
    login: process.env.REACT_APP_AUTH_URL + "/login",
    automaticSilentRenew: true,
    loadUserInfo: true,
    silent_redirect_uri: window.location.protocol + "//" + window.location.hostname + (window.location.port != "" ? ":" + window.location.port : "") + process.env.REACT_APP_SILENT_REDIRECT_URL,
    post_logout_redirect_uri: window.location.protocol + "//" + window.location.hostname + (window.location.port != "" ? ":" + window.location.port : "") + process.env.REACT_APP_LOGOFF_REDIRECT_URL,
    audience: entra ? "api://6f049207-e05b-4697-b87a-5bcbfee76201" : "https://aquaguardapi.co.uk",
    response_type: "code",
    response_mode: "query",
    grantType: entra ? "authorization_code" : "password",
    scope: entra ? "api://6f049207-e05b-4697-b87a-5bcbfee76201/.default" : "openid profile email AG_DatabaseAPI ASH_LicenseAPI ASH_IdentityAPI ashridge.profile",
    code_challenge_method: entra ? "S256" : undefined, // ADD THIS - enables PKCE
    webAuthResponseType: entra ? undefined : "id_token token" // CHANGE THIS - remove for code flow
};

export const METADATA_OIDC = entra
    ? undefined // CHANGE THIS - let oidc-client auto-discover Entra endpoints
    : {
        issuer: process.env.REACT_APP_AUTH_URL,
        jwks_uri: process.env.REACT_APP_AUTH_URL + "/.well-known/openid-configuration/jwks",
        authorization_endpoint: process.env.REACT_APP_AUTH_URL + "/connect/authorize",
        token_endpoint: process.env.REACT_APP_AUTH_URL + "/connect/token",
        userinfo_endpoint: process.env.REACT_APP_AUTH_URL + "/connect/userinfo",
        end_session_endpoint: process.env.REACT_APP_AUTH_URL + "/connect/endsession",
        check_session_iframe: process.env.REACT_APP_AUTH_URL + "/connect/checksession",
        revocation_endpoint: process.env.REACT_APP_AUTH_URL + "/connect/revocation",
        introspection_endpoint: process.env.REACT_APP_AUTH_URL + "/connect/introspect",
    };